import type { QuickDashboardTileProps } from './quick-dashboard-tile.types.ts';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './quick-dashboard-tile.module.scss';

export function QuickDashboardTile({ className, title, colour, icon, route }: QuickDashboardTileProps) {
  const navigate = useNavigate();

  return (
    <div
      className={`${styles.tile} ${className}`}
      style={{ backgroundColor: colour }}
      onClick={(e) => {
        e.stopPropagation();
        navigate(route);
      }}
    >
      <FontAwesomeIcon size={'4x'} icon={icon} />
      <span>{title}</span>
    </div>
  );
}
